module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Victoria-S3.cd7eb9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Victoria-S3.jpg
// module id = Ycbt
// module chunks = 0